/** Normalize pin payload from socket or API into Redux pinnedMessage shape. */
export const normalizePinnedMessage = (payload) => {
    if (!payload) return null;

    let pin = null;
    if (payload.type === "pin") {
        pin = payload;
    } else if (payload.data?.type === "pin") {
        pin = payload.data;
    }

    if (!pin) return null;

    const msg = pin.attributes?.message;
    const messageId = pin.id ?? msg?.id;
    if (messageId == null) return null;

    const id = String(messageId);

    return {
        ...pin,
        id,
        type: "pin",
        attributes: {
            ...pin.attributes,
            message: msg
                ? {
                      ...msg,
                      id: String(msg.id ?? messageId),
                  }
                : msg,
        },
    };
};

/** Build pin state from a sent message payload when pin socket was missed. */
export const buildPinnedMessageFromSend = (messageData) => {
    if (!messageData?.id) return null;

    const attrs = messageData.attributes || {};
    const id = String(messageData.id);

    return {
        id,
        type: "pin",
        attributes: {
            pinnedAt: attrs.createdAt || new Date().toISOString(),
            message: {
                id,
                sanitizedText: attrs.sanitizedText,
                text: attrs.text,
                user: attrs.user,
                createdAt: attrs.createdAt,
                media: attrs.media,
            },
        },
    };
};

export const messageIdsMatch = (a, b) => {
    if (a == null || b == null) return false;
    return String(a) === String(b);
};
